import React, { useState } from "react";
import { formatWords, keyToTitle } from "../../../../../utils";
import { Button, Chip, InfoText, InfoTimeCardAdv, InfoWrapper, NewTab, StatusTags } from "../../../../../components";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { useNavigate } from "react-router-dom";
import Info from "./AiJobDetail/Info";
import Candidates from "./AiJobDetail/Candidates";
import CallScheduleList from "./AiJobDetail/CallScheduleList";
import AiCallHistory from "./AiJobDetail/AiCallHistory";

const AiJobDetails = () => {
  const [jobDetails, setJobDetails] = useState(null);
  const [talentMatchData, setTalentMatchData] = useState(null);
  const navigate = useNavigate();

  let generalJobDetails = [
    {
      "Job Title": formatWords2(jobDetails?.jobId?.title || "N/A"),
      Location: `${formatWords2(location?.city || "N/A")}, ${formatWords2(location?.state || "N/A")}`,
      Position: jobDetails?.jobInfo?.type || "N/A",
      "Position Opened": jobDetails?.jobInfo?.reqHourWeek || "N/A", // doubt
      "Position Closed": jobDetails?.jobInfo?.duration || "N/A", // doubt
    },
  ];

  let secondaryDetails = [
    {
      "Show Created by": formatWords2(jobDetails?.addedBy?.firstName || "N/A"),
      "Modified by": formatWords2(
        jobDetails?.jobId?.modifiedBy?.firstName || "N/A",
      ),
      "Created on": jobDetails?.addedOn
        ? formatDate(convertFromUTC(jobDetails?.addedOn))
        : "N/A",
      "Modified On": jobDetails?.updatedAt
        ? formatDate(convertFromUTC(jobDetails?.updatedAt))
        : "N/A",
      "Talent Match(Count of Candidate)": talentMatchData || [
        { count: "0", percentage: "80-100%", color: "primary" },
        { count: "0", percentage: "50-80%", color: "info" },
        { count: "0", percentage: "< 50%", color: "leave" },
      ],
    },
  ];

  const infoCardDetails = [
    { title: "Candidates Found", value:  0 },
    { title: "AI Calls Made", value:  0 },
    { title: "Interested", value:  0 },
    { title: "Not Interested", value:  0 },
  ];

  const jobDetailMenus=[
    {
      title: "Info",
      page: <Info />,
      type: "main",
      id: "aijobsdetailsuiid_info",
    },
    {
      title: "Candidates",
      page: <Candidates />,
      type: "main",
      id: "aijobsdetailsuiid_candidates",
    },
    {
      title: "Call Schedule List",
      page: <CallScheduleList />,
      type: "main",
      id: "aijobsdetailsuiid_call_schedule_list",
    },
    {
      title: "AI Call History",
      page: <AiCallHistory />,
      type: "main",
      id: "aijobsdetailsuiid_ai_call_history",
    },
    
  ]
  return (
    <div className="flex flex-col gap-5 flex-1">
      <div className="flex justify-between items-center mr-4 mt-3">
        <Button
          title="Job Post Details"
          color="black"
          variant="text"
          size="md"
          fromLeft
          icon="arrow_left_alt"
          className="self-start text-md font-semibold px-0!"
          onClick={() => {
            navigate("/ats/jobs/?jobs=ai-recruiter-jobs");
          }}
          // onClick={() => {
          //   if (window.history.state && window.history.state.idx > 0) {
          //     navigate(-1);
          //   } else {
          //     navigate("/ats/jobs?jobs=all-jobs");
          //   }
          // }}
          //   onClick={() => {
          //     if (prevPage) {
          //       if (prevPage?.includes("applicants/applicant-details")) {
          //         navigate(prevPage, {state: {applicantId}})
          //       } else {
          //         navigate(prevPage);
          //       }
          //     } else {
          //       navigate("/ats/jobs?jobs=all-jobs");
          //     }
          //   }}
        />
        {/* <div className="flex gap-2">
          {user?.data?.role?.type === 3 && jobDetails?.addedBy?.uiid === user?.data?.uiid &&
            <Button
              variant="outlined"
              title={"Edit"}
              icon={"edit_square"}
              onClick={() => setOpenEditModal(true)}
            />
          }

          <Button title={"Job Boards"} onClick={handleJobBoardsClick} />
        </div> */}
      </div>

      <div className="flex justify-between items-center gap-1 ">
        <div className="flex gap-2 items-center">
          <h6 className="subtitle-reg ml-1 mr-1">
            {formatWords("NESU-070433-729843286906423")}
            {/* {formatWords(jobInfo?.jobCode)} */}
          </h6>
          <p className=" text-xs font-[600] text-gray-400 mr-3">
            (Opened 3 days ago)
            {/* ({getDaysSinceAdded(jobDetails?.addedOn)}
            ) */}
          </p>
          <StatusTags
            icon
            size="lg"
            //   tag={latestStatus}
          />
        </div>
      </div>
      <div className=" grid grid-cols-4 md:grid-cols-3 lg:grid-cols-5 gap-5 my-1 inner-section px-4 py-6 rounded">
        {Object.entries(generalJobDetails[0]).map(([key, value]) => {
          return (
            <InfoText
              size="sm"
              key={key}
              title={keyToTitle(key)}
              value={value}
            />
          );
        })}
      </div>
      <div className="flex gap-5 my-1 inner-section p-4 rounded">
        <div className="grid md:grid-cols-2 xl:grid-cols-4 lg:grid-cols-3 gap-5">
          {Object.entries(secondaryDetails[0]).map(([key, value]) => {
            const isTalentMatch = key === "Talent Match(Count of Candidate)";
            const displayValue = isTalentMatch ? (
              <div className="flex gap-3">
                {value.map((data, index) => (
                  <div className="flex flex-col gap-2 items-center" key={index}>
                    <Chip
                      key={index}
                      label={data.count}
                      color={data.color}
                      variant="outlined"
                      size="lg"
                      className={`!px-4 py-3 rounded-xl bg-${data?.color}-50 !text-xs`}
                    />
                    <div className="text-xs">{data?.percentage}</div>
                  </div>
                ))}
              </div>
            ) : (
              value
            );

            return (
              <div className={isTalentMatch ? "col-span-3" : ""} key={key}>
                <InfoText
                  size="sm"
                  title={keyToTitle(key)}
                  value={displayValue}
                />
              </div>
            );
          })}
        </div>
      </div>

      <InfoWrapper>
        {infoCardDetails.map((item) => (
          <InfoTimeCardAdv
            title={item.title}
            value={item.value}
            variant={"text"}
            color={"primary"}
            size="sm"
          />
        ))}
      </InfoWrapper>

      <div className="flex-1 rounded-xl">
        <NewTab
          tabs={jobDetailMenus}
          color="gray"
          variant="text"
          activeVariant="text"
          mode="url"
          tabId="job-details"
        />
      </div>

      {/* <Modal
        isOpen={openEditModal}
        onClose={() => setOpenEditModal(false)}
        title={"Edit"}
        titleColor={"primary"}
        // width="max-w-4xl"
        width="w-full"
      >
        
        <AddJobPost
          onCancel={() => setOpenEditModal(false)}
          editData={jobDetails}
          onSuccess={() => {
            setOpenEditModal(false);
            getJobDetails();
          }}
        />
      </Modal> */}
    </div>
  );
};

export default AiJobDetails;
